import React from 'react';
import classes from './ToggleButton.css'

const ToggleButton=(props)=>{


	return(
		<button onClick= {props.click} className={classes.ToggleButton}></button>
		)
}

export default ToggleButton;


// WEBPACK FOOTER //
// ./src/components/Navigation/ToggleButton/ToggleButton.jsx